import React, {Component} from "react";
import config from 'react-global-configuration';
import {Nav, Navbar, NavItem} from "react-bootstrap";
import jwt_decode from "jwt-decode";
import {Link} from "react-router-dom";
import $ from "jquery";


class commonNavbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emiMenus:[]
        };

    }
    componentDidMount() {
        this.getEmiRoutes();
    }

    getEmiRoutes(){
        let emiMenus = [];
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        
        let accessPermissions = [];
        if(tokenPermission != null) {
            const decoded_permission = jwt_decode(tokenPermission);
            accessPermissions = decoded_permission.accessPermissions;
        }
        let emiRoutes = [
            // {
            //     path: "/master-data",
            //     name: "Master Data",
            //     menu_per: "master_data_view",
            //     icon: "pe-7s-server",
            //     //component: MasterData,
            //     layout: "/admin",
            //     isDrop: false,
            //     submenus:[]
            // },
            // {
            //     path: "/index-data",
            //     name: "Index Data",
            //     menu_per: "index_data",
            //     icon: "pe-7s-menu",
            //     //component: Index_Data,
            //     layout: "/admin",
            //     isDrop: false,
            //     submenus:[]
            // },
            {
                path: "/unmapped-view",
                name: "Master Data Unmapped View",
                menu_per: "master_data_unmapped_view",
                icon: "pe-7s-server",
                //component: Unmapped_View,
                layout: "/admin",
                isDrop: false,
                submenus:[]
            },
            {
                path: "/mapped-view",
                name: "Master Data Mapped View",
                menu_per: "master_data_mapped_view",
                icon: "pe-7s-server",
                //component: Mapped_View,
                layout: "/admin",
                isDrop: false,
                submenus:[]
            },
            // {
            //     path: "/be-dashboard",
            //     name: "Dashboard",
            //     menu_per: "be_dashboard",
            //     icon: "pe-7s-albums",
            //     //component: UploadSkus,
            //     layout: "/admin",
            //     isDrop: false,
            //     submenus:[]
            // },
            {
                path: "/brand-product-master",
                name: "Products",
                menu_per: "product_master",
                icon: "pe-7s-albums",
                //component: UploadSkus,
                layout: "/admin",
                isDrop: false,
                submenus:[]
            },
            {
                path: "/merchant-product-master",
                name: "Products",
                menu_per: "merchant_product_master",
                icon: "pe-7s-albums",
                //component: UploadMskus,
                layout: "/admin",
                isDrop: false,
                submenus:[]
            },
            {
                path: "/new-schemes-master",
                name: "Schemes",
                menu_per: "scheme_master",
                icon: "pe-7s-cloud-upload",
                //component: Subvention_Merchant,
                layout: "/admin",
                isDrop: false,
                submenus:[]
            },
            
            
            // {
            //     path: "/subvention-merchant",
            //     name: "Subvention Merchant",
            //     menu_per: "merchant_upload_subvention",
            //     icon: "pe-7s-cloud-upload",
            //     //component: Subvention_Merchant,
            //     layout: "/admin",
            //     isDrop: false,
            //     submenus:[]
            // },
            
            // {
            //     path: "/api-configuration",
            //     name: "API Configuration",
            //     menu_per: "api_configuration",
            //     icon: "pe-7s-tools",
            //     //component: API_Configuration,
            //     layout: "/admin",
            //     isDrop: false,
            //     submenus:[]
            // },
            {
                path: "/admin-upload-products",
                name: "Products",
                menu_per: "admin_product_master",
                icon: "pe-7s-cloud-upload",
                //component: Subvention_Innoviti,
                layout: "/admin",
                isDrop: false,
                submenus:[]
            },
            {
                path: "/admin-new-schemes-list",
                name: "Schemes",
                menu_per: "admin_scheme_master",
                icon: "pe-7s-cloud-upload",
                //component: Subvention_Innoviti,
                layout: "/admin",
                isDrop: false,
                submenus:[]
            },
            {
                path: "/merchant-master",
                name: "Merchants",
                menu_per: "merchant_master",
                icon: "pe-7s-cloud-upload",
                //component: Subvention_Innoviti,
                layout: "/admin",
                isDrop: false,
                submenus:[]
            },
            {
                path: "/view-promotion-list",
                name: "Promotions",
                menu_per: "promotions",
                icon: "pe-7s-cash",
                //component: Subvention_Brand,
                layout: "/admin",
                isDrop: false,
                submenus:[]
            },
            {
                path: "/admin-promotion-master",
                name: "Promotions",
                menu_per: "run_promotions",
                icon: "pe-7s-cloud-upload",
                //component: Subvention_Innoviti,
                layout: "/admin",
                isDrop: false,
                submenus:[]
            },
            // {
            //     path: "/data-exporter",
            //     name: "Exporter",
            //     menu_per: "data_exporter",
            //     icon: "pe-7s-cash",
            //     //component: Subvention_Brand,
            //     layout: "/admin",
            //     isDrop: false,
            //     submenus:[]
            // },
            {
                path: "/promotion-mapping",
                name: "Promotion Mapping",
                menu_per: "promotion_mapping",
                icon: "pe-7s-cloud-upload",
                //component: Subvention_Innoviti,
                layout: "/admin",
                isDrop: false,
                submenus:[]
            },
        ];

        emiRoutes.map((menuName, index) => {
            accessPermissions.map((permissionName, i) => {
                if(permissionName.access_name==menuName.menu_per) {
                    emiMenus.push(emiRoutes[index]);
                }
            });
        });
        this.setState({
            emiMenus: emiMenus
        })
    }

    render() {
        let menus = this.state.emiMenus.map((menu, index) =>{
            return (
                <NavItem key={index + "_" + 5} eventKey={index + "_" + 5} componentClass={Link} href={menu.layout+menu.path } to={menu.layout+menu.path}>
                    {menu.name}
                </NavItem>
            )
        });

        return (
                <div className="container-fluid">
                    <div className = "row">
                        
                                <Navbar className="BrandNav" fluid >
                                    <Navbar.Header>
                                        {/*<Navbar.Brand>*/}
                                        {/*  <a href="#pablo">{this.props.brandText}</a>*/}
                                        {/*</Navbar.Brand>*/}
                                        <Navbar.Toggle onClick={this.mobileSidebarToggle} />
                                    </Navbar.Header>
                                    <Navbar.Collapse>
                                        <Nav pullLeft>
                                            {menus}
                                        </Nav>
                                    </Navbar.Collapse>
                                </Navbar>

                            

                    </div>
                </div>
            

        );

    }


}
export default commonNavbar;